export default class StripeSettings {
  enablePayouts?: boolean;

  constructor(pojo?: StripeSettings) {
    this.enablePayouts = pojo?.enablePayouts;
  }
}
